import { SpeechBabbleProps } from "../../../new-components/SpeechBabble/SpeechBabble"

// Retail
import Website from "../../../../images/industries_/website.inline.svg"
import App from "../../../../images/industries_/app.inline.svg"
import Parking from "../../../../images/industries_/parking.inline.svg"
import Cashier from "../../../../images/industries_/cashier.inline.svg"
import CustomerService from "../../../../images/industries_/customer-service.inline.svg"
import Email from "../../../../images/industries_/email.inline.svg"
import CallCenter from "../../../../images/industries_/call-center.inline.svg"
import EntranceExit from "../../../../images/industries_/entrance-exit.inline.svg"

// Hospitality
import Lobby from "../../../../images/industries_/lobby.inline.svg"
import Giftshop from "../../../../images/industries_/giftshop.inline.svg"
import Hotelroom from "../../../../images/industries_/hotelroom.inline.svg"
import Restaurant from "../../../../images/industries_/restaurant.inline.svg"
import Pool from "../../../../images/industries_/pool.inline.svg"

// Restaurant
import Informationdesk from "../../../../images/industries_/informationdesk.inline.svg"
import Bar from "../../../../images/industries_/bar.inline.svg"
import Tablerestaurant from "../../../../images/industries_/tablerestaurant.inline.svg"
import Washroom from "../../../../images/industries_/washroom.inline.svg"

// Healthcare
import Receptionhospital from "../../../../images/industries_/receptionhospital.inline.svg"
import Waitingroom from "../../../../images/industries_/waitingroom.inline.svg"
import Hospitalbed from "../../../../images/industries_/hospitalbed.inline.svg"

// Property
import Elevator from "../../../../images/industries_/elevator.inline.svg"
import Office from "../../../../images/industries_/office.inline.svg"
import Gym from "../../../../images/industries_/gym.inline.svg"
import Room from "../../../../images/industries_/room.inline.svg"
import Concierge from "../../../../images/industries_/concierge.inline.svg"

// Transportation
import Mobileapp from "../../../../images/industries_/mobileapp.inline.svg"
import Atm from "../../../../images/industries_/atm.inline.svg"
import Busstop from "../../../../images/industries_/busstop.inline.svg"
import Baggageclaim from "../../../../images/industries_/baggageclaim.inline.svg"
import Securitycheck from "../../../../images/industries_/securitycheck.inline.svg"
import Passportcontrol from "../../../../images/industries_/passportcontrol.inline.svg"
import Buseat from "../../../../images/industries_/buseat.inline.svg"

// Deskless Employee
import Timeclock from "../../../../images/industries_/timeclock.inline.svg"
import Officedesk from "../../../../images/industries_/officedesk.inline.svg"
import Employeearea from "../../../../images/industries_/employeearea.inline.svg"
import Sms from "../../../../images/industries_/sms.inline.svg"
import Check from "../../../../images/industries_/check.inline.svg"

export enum SolutionPages {
  RETAIL = "retail",
  HOSPITALITY = "hospitality",
  RESTAURANT = "restaurant",
  HEALTHCARE = "healthcare",
  PROPERTY = "property",
  TRANSPORTATION = "transportation",
  DESKLESS_EMPLOYEE = "deskless-employee",
}

type itemProperty = {
  title: string
  link: string
  svg: any
  details: SpeechBabbleProps
}

const handleTypeCircleMenu = (
  type: SolutionPages
): Array<itemProperty | any> => {
  if (type === SolutionPages.RETAIL) {
    return [
      {
        title: "Call Center",
        link: "/customer/industry/Retail/touchpoint/Call%20Center",
        svg: CallCenter,
        details: {
          //   text: "Collect customer feedback after phone calls to improve customer service and agent performance.",
          text: "Collect customer feedback after phone calls to improve...",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Entrance & Exit",
        link: "/customer/industry/Retail/touchpoint/Entrance%20&%20Exit",
        svg: EntranceExit,
        details: {
          //   text: "Understand overall customer experience at retail store locations when they leave the store.",
          text: "Understand overall customer experience at retail store locations...",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Website",
        link: "/customer/industry/Retail/touchpoint/Website",
        svg: Website,
        details: {
          //   text: "Monitor your shoppers experience in your website during checkout, searching for product, looking for information.",
          text: "Monitor your shoppers experience in your website during...",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "App",
        link: "/customer/industry/Retail/touchpoint/App",
        svg: App,
        details: {
          text: "Collect feedback from customers inside your retail mobile app and...",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Customer Service",
        link: "/customer/industry/Retail/touchpoint/Customer%20Service",
        svg: CustomerService,
        details: {
          //   text: "Develop retail brand loyalty through a unique customer service by hearing the voice of customers.",
          text: "Develop retail brand loyalty through a unique customer...",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Parking",
        link: "/customer/industry/Retail/touchpoint/Parking",
        svg: Parking,
        details: {
          text: "Understand customer feedback for on premise parking of...",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Cashier",
        link: "/customer/industry/Retail/touchpoint/Cashier",
        svg: Cashier,
        details: {
          //   text: "Collect shoppers' feedback from self-checkout or cashier in retail stores.",
          text: "Collect shoppers' feedback from self-checkout or cashier...",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },
      {
        title: "Email",
        link: "/customer/industry/Retail/touchpoint/Email",
        svg: Email,
        details: {
          //   text: "Engage your customers via feedback email request after placing an order with your retail brand.",
          text: "Engage your customers via feedback email request after placing...",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }

  if (type === SolutionPages.HOSPITALITY) {
    return [
      {
        title: "Shop",
        link: "/customer/industry/Hospitality/touchpoint/Shop",
        svg: Giftshop,
        details: {
          //   text: "Collect feedback from guests when they shop at hotel retail stores during their stay.",
          text: "Collect feedback from guests when they shop at hotel retail stores...",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Entrance & Exit",
        link: "/customer/industry/Hospitality/touchpoint/Entrance%20&%20Exit",
        svg: EntranceExit,
        details: {
          //   text: "Understand overall guest experience on their way out from the hotel properties.",
          text: "Understand overall guest experience on their way out from the...",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Website",
        link: "/customer/industry/Hospitality/touchpoint/Website",
        svg: Website,
        details: {
          //   text: "Collect feedback from guests in your hotel website when reserving a room or checking information.",
          text: "Collect feedback from guests in your hotel website when reserving...",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "Reception",
        link: "/customer/industry/Hospitality/touchpoint/Reception",
        svg: CustomerService,
        details: {
          //   text: "Understand guest experience and effectiveness of check-in and check-out process at the reception area as they interact with the staff.",
          text: "Understand guest experience and effectiveness of check...",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Lobby",
        link: "/customer/industry/Hospitality/touchpoint/Lobby",
        svg: Lobby,
        details: {
          //   text: "Hear your guests overall experience as they are enjoying the hotel lobby.",
          text: "Hear your guests overall experience as they are enjoying the hotel lobby.",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Room",
        link: "/customer/industry/Hospitality/touchpoint/Room",
        svg: Hotelroom,
        details: {
          //   text: "Give an opportunity to your guests to give feedback when they are in their room.",
          text: "Give an opportunity to your guests to give feedback when they...",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Restaurant",
        link: "/customer/industry/Hospitality/touchpoint/Restaurant",
        svg: Restaurant,
        details: {
          //   text: "Collect guest and customer feedback in the restaurant and bar of hotel to ensure their dinning expectations are met.",
          text: "Collect guest and customer feedback in the restaurant and bar...",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },

      {
        title: "Pool & Gym",
        link: "/customer/industry/Retail/touchpoint/Email",
        svg: Pool,
        details: {
          //   text: "Listen to your guest feedback about the recreation services, gym and pool of the hotel.",
          text: "Listen to your guest feedback about the recreation services, gym...",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }

  if (type === SolutionPages.RESTAURANT) {
    return [
      {
        title: "Cashier",
        link: "/customer/industry/Restaurant/touchpoint/Cashier",
        svg: Cashier,
        details: {
          //   text: "Hear customer feedback when ordering or picking up the food at the restaurant cashier.",
          text: "Hear customer feedback when ordering or picking up the food at the...",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Entrance & Exit",
        link: "/customer/industry/Restaurant/touchpoint/Exit",
        svg: EntranceExit,
        details: {
          //   text: "Understand overall customer experience on their way out from the restaurant.",
          text: "Understand overall customer experience on their way out from the...",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Website",
        link: "/customer/industry/Restaurant/touchpoint/Website",
        svg: Website,
        details: {
          //   text: "Collect feedback from customers in your website when ordering, checking menu, opening hours.",
          text: "Collect feedback from customers in your website when ordering...",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "Parking",
        link: "/customer/industry/Restaurant/touchpoint/Parking",
        svg: Parking,
        details: {
          //   text: "Understand customer feedback when they use valet or on premise parking of restaurant and franchise.",
          text: "Understand customer feedback when they use valet or on premise...",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Host",
        link: "/customer/industry/Restaurant/touchpoint/Host",
        svg: Informationdesk,
        details: {
          //   text: "Collect guests feedback when they check in with the host or request a table in the restaurant.",
          text: "Collect guests feedback when they check in with the host or request a...",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Bar",
        link: "/customer/industry/Restaurant/touchpoint/Bar",
        svg: Bar,
        details: {
          //   text: "Hear your guest feedback in real-time as they are enjoying their drink and food.",
          text: "Hear your guest feedback in real-time as they are enjoying their...",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Table",
        link: "/customer/industry/Restaurant/touchpoint/Table",
        svg: Tablerestaurant,
        details: {
          //   text: "Tables in restaurant are great place to collect real-time feedback from customers.",
          text: "Tables in restaurant are great place to collect real-time feedback from...",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },
      {
        title: "Washroom",
        link: "/customer/industry/Restaurant/touchpoint/Washroom",
        svg: Washroom,
        details: {
          //   text: "Collect customer feedback when using the washrooms to ensure the expected cleanliness is met at all time.",
          text: "Collect customer feedback when using the washrooms to...",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }

  if (type === SolutionPages.HEALTHCARE) {
    return [
      {
        title: "Website",
        link: "/customer/industry/Healthcare/touchpoint/Website/",
        svg: Website,
        details: {
          //   text: "Collect feedback regarding patients first impression",
          text: "Collect feedback regarding patients first impression",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Entrance & Exit",
        link: "/customer/industry/Healthcare/touchpoint/Entrance%20&%20Exit/",
        svg: EntranceExit,
        details: {
          //   text: "Understand overall patient experience when they leave hospital or clinic.",
          text: "Collect feedback regarding overall patient experience",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Reception",
        link: "/customer/industry/Healthcare/touchpoint/Reception/",
        svg: Receptionhospital,
        details: {
          //   text: "Collect feedback regarding patients first impression",
          text: "Collect feedback regarding patients first impression",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "Call Center",
        link: "/customer/industry/Healthcare/touchpoint/Call%20Center/",
        svg: CallCenter,
        details: {
          text: "Collect feedback from patient after the call",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Waiting Room",
        link: "/customer/industry/Healthcare/touchpoint/Waiting%20Room/",
        svg: Waitingroom,
        details: {
          text: "Collect feedback regarding waiting room",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Retail Shops",
        link: "/customer/industry/Healthcare/touchpoint/Food%20&%20Shops/",
        svg: Giftshop,
        details: {
          text: "Collect feedback at the retail shops in your facilities",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Room",
        link: "/customer/industry/Healthcare/touchpoint/Room/",
        svg: Hospitalbed,
        details: {
          text: "Gauge feedback from patients during their stay",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },
      {
        title: "Department",
        link: "/customer/industry/Healthcare/touchpoint/Laboratory/",
        svg: Employeearea,
        details: {
          text: "Collect patient feedback at different departments",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }

  if (type === SolutionPages.PROPERTY) {
    return [
      {
        title: "Recreation",
        link: "/customer/industry/Property%20Management/touchpoint/Recreation",
        svg: Gym,
        details: {
          //   text: "Hear residents and clients feedback and concern when using gym & pool facilities of the building.",
          text: "Hear residents and clients feedback and concern when using...",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Entrance & Exit",
        link: "/customer/industry/Property%20Management/touchpoint/Entrance%20&%20Exit",
        svg: EntranceExit,
        details: {
          //   text: "Continuously monitor overall visitors and resident experience at exit doors of property.",
          text: "Continuously monitor overall visitors and resident experience at...",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Elevator",
        link: "/customer/industry/Property%20Management/touchpoint/Elevator",
        svg: Elevator,
        details: {
          //   text: "Collect feedback inside elevators of property and buildings.",
          text: "Collect feedback inside elevators of property and buildings.",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "Management",
        link: "/customer/industry/Property%20Management/touchpoint/Management",
        svg: Office,
        details: {
          //   text: "Measure clients and visitors experience stop by the management office.",
          text: "Measure clients and visitors experience stop by the management...",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Common Room",
        link: "/customer/industry/Property%20Management/touchpoint/Common%20Room",
        svg: Lobby,
        details: {
          //   text: "Collect feedback from residents when using common room and social room.",
          text: "Collect feedback from residents when using common room and...",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Inside Flat",
        link: "/customer/industry/Property%20Management/touchpoint/Inside%20Flat",
        svg: Room,
        details: {
          //   text: "Give a voice to your residents when they're in their units and flat.",
          text: "Give a voice to your residents when they're in their units and flat.",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Concierge",
        link: "/customer/industry/Property%20Management/touchpoint/Concierge",
        svg: Concierge,
        details: {
          //   text: "Gauge clients and residents feedback as they interact with the concierge.",
          text: "Gauge clients and residents feedback as they interact with the...",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },
      {
        title: "Parking",
        link: "/customer/industry/Property%20Management/touchpoint/Parking",
        svg: Parking,
        details: {
          //   text: "Ask about parking and valet experience from your clients, visitors and residents.",
          text: "Ask about parking and valet experience from your clients, visitors and...",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }

  if (type === SolutionPages.TRANSPORTATION) {
    return [
      {
        title: "Ticket Kiosk",
        link: "/customer/industry/Transportation/touchpoint/Ticket%20Kiosk",
        svg: Atm,
        details: {
          //   text: "Automated Ticket Kiosk",
          text: "Automated Ticket Kiosk",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Ground Transportation",
        link: "/customer/industry/Transportation/touchpoint/Ground%20Transportation",
        svg: Buseat,
        details: {
          //   text: "Communication via sms",
          text: "Communication via sms",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Website",
        link: "/customer/industry/Transportation/touchpoint/Website",
        svg: Website,
        details: {
          //   text: "Website",
          text: "Website",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "App",
        link: "/customer/industry/Transportation/touchpoint/App",
        svg: Mobileapp,
        details: {
          //   text: "Mobile app",
          text: "Mobile app",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Passport Control",
        link: "/customer/industry/Transportation/touchpoint/Passport%20Control",
        svg: Passportcontrol,
        details: {
          //   text: "Bus or Train seats",
          text: "Bus or Train seats",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Waiting Area",
        link: "/customer/industry/Transportation/touchpoint/Waiting%20Area",
        svg: Busstop,
        details: {
          //   text: "Bus or Train Shelter",
          text: "Bus or Train Shelter",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Baggage Claim",
        link: "/customer/industry/Transportation/touchpoint/Baggage%20Claim",
        svg: Baggageclaim,
        details: {
          //   text: "Bus or Train seats",
          text: "Bus or Train seats",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },
      {
        title: "Security Check",
        link: "/customer/industry/Transportation/touchpoint/Security%20Check",
        svg: Securitycheck,
        details: {
          //   text: "Bus or Train seats",
          text: "Bus or Train seats",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }

  if (type === SolutionPages.DESKLESS_EMPLOYEE) {
    return [
      {
        title: "Email",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Email",
        svg: Email,
        details: {
          //   text: "Collect feedback though all emails and business signature",
          text: "Collect feedback though all emails and business signature",
          x: "-230px",
          y: "-190px",
          type: "top-right",
        },
      },
      {
        title: "Intranet Portal",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Intranet%20Portal",
        svg: Website,
        details: {
          //   text: "Collect feedback from your employee portals and intranet",
          text: "Collect feedback from your employee portals and intranet",
          x: "-230px",
          y: "150px",
          type: "bottom-right",
        },
      },
      {
        title: "Timeclock",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Timeclock",
        svg: Timeclock,
        details: {
          //   text: "Collect your workers and employee feedback when they arrive and leave.",
          text: "Collect your workers and employee feedback when they arrive and...",
          x: "-260px",
          y: "95px",
          type: "bottom-right",
        },
      },
      {
        title: "Department",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Department",
        svg: Officedesk,
        details: {
          //   text: "Collect department-based feedback from employees and workers.",
          text: "Collect department-based feedback from employees and workers.",
          x: "90px",
          y: "95px",
          type: "bottom-left",
        },
      },
      {
        title: "Employee area",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Employee%20area",
        svg: Employeearea,
        details: {
          //   text: "Collect feedback when they are relax and ready to submit one",
          text: "Collect feedback when they are relax and ready to submit one",
          x: "70px",
          y: "130px",
          type: "bottom-left",
        },
      },
      {
        title: "Shuttle",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Shuttle",
        svg: Busstop,
        details: {
          //   text: "Collect feedback regarding transportation and shuttle service",
          text: "Collect feedback regarding transportation and shuttle service",
          x: "35px",
          y: "-180px",
          type: "top-left",
        },
      },
      {
        title: "Phone",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Phone",
        svg: Sms,
        details: {
          //   text: "Collect feedback through SMS from employees",
          text: "Collect feedback through SMS from employees",
          x: "90px",
          y: "-145px",
          type: "top-left",
        },
      },
      {
        title: "Paycheck",
        link: "/employee/industry/Deskless%20Employee/touchpoint/Paycheck",
        svg: Check,
        details: {
          //   text: "Encourage employees to submit feedback after receiving their pay check",
          text: "Encourage employees to submit feedback after receiving their pay check",
          x: "-260px",
          y: "-145px",
          type: "top-right",
        },
      },
    ]
  }
  return []
}

export default handleTypeCircleMenu
